import { useTranslation } from "react-i18next";
import { Col, Form, MenuProps, Row, Spin, Switch, Typography } from "antd";
import { FormInstance } from "antd/lib";
import { FunctionComponent, useEffect, useState } from "react";
import FormInput from "../../../../../components/form-input/FormInput";
import FormItemDropdown from "../../../../../components/form-dropdown/FormItemDropdown";
import { get, isEmpty } from "lodash";
import { useForm, useWatch } from "antd/es/form/Form";
import { getIndustryStudent } from "../../../../../service/category-management/student-management";
import { regexEmailV2, phoneNumberRegex, regexEmail } from "../../../../../utils/regex";
import { getAllIndustry } from "../../../../../service/course-construct";



type FormCreateUniversityProps = {
	form: FormInstance,
	onFinish?: any,
	dataOptions?: any,
	loadingForm: boolean,
}



const FormCreateUniversity: FunctionComponent<FormCreateUniversityProps> = ({ form, onFinish, dataOptions, loadingForm }) => {
  const { t } = useTranslation();

  const validations = {
	name: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (value && value.length > 512) {
				return Promise.reject(new Error(t("Tên sinh viên không vượt quá 512 ký tự", "Tên sinh viên không vượt quá 512 ký tự")))
			}
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng nhập tên sinh viên", "Vui lòng nhập tên sinh viên")))
			}
			return Promise.resolve()
		}
	},
	code: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (value && value.length > 512) {
				return Promise.reject(new Error(t("Mã sinh viên không vượt quá 512 ký tự", "Mã sinh viên không vượt quá 512 ký tự")))
			}
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng nhập mã sinh viên", "Vui lòng nhập mã sinh viên")))
			}
			return Promise.resolve()
		}
	},
	university: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng chọn cơ sở đào tạo", "Vui lòng chọn cơ sở đào tạo")))
			}
			return Promise.resolve()
		}
	},
	department: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!value || value.length < 1) {
				return Promise.reject(new Error(t("Vui lòng chọn khoa", "Vui lòng chọn khoa")))
			}
			return Promise.resolve()
		}
	},
	specialized: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!value || value.length < 1) {
				return Promise.reject(new Error(t("Vui lòng chọn chuyên ngành", "Vui lòng chọn chuyên ngành")))
			}
			return Promise.resolve()
		}
	},
	gender: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng chọn giới tính", "Vui lòng chọn giới tính")))
			}
			return Promise.resolve()
		}
	},
	domicile: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng chọn nguyên quán", "Vui lòng chọn nguyên quán")))
			}
			return Promise.resolve()
		}
	},
	phone: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!isEmpty(value) && !value.match(new RegExp(phoneNumberRegex))) {
				return Promise.reject(new Error(t("Sai định dạng, vui lòng nhập lại", "Sai định dạng, vui lòng nhập lại")))
			}
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng nhập số điện thoại", "Vui lòng nhập số điện thoại")))
			}
			return Promise.resolve()
		}
	},
	email: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!isEmpty(value) && !value.match(new RegExp(regexEmail))) {
				return Promise.reject(new Error(t("Sai định dạng, vui lòng nhập lại", "Sai định dạng, vui lòng nhập lại")))
			}
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng nhập địa chỉ email", "Vui lòng nhập địa chỉ email")))
			}
			return Promise.resolve()
		}
	},
}

  const gendersOptions = [
    {
      id: "Nam",
      name: t("Nam", "Nam"),
    },
    {
      id: t("Nữ", "Nữ"),
      name: t("Nữ", "Nữ"),
    },
	{
	  id: t("Khác", "Khác"),
	  name: t("Khác", "Khác"),
	},
];

	const departmentId = useWatch("department", form);
	const [loadingDataSpecialized, setLoadingDataSpecialized] = useState<boolean>(false);
	const [dataSpecialized, setDataSpecialized] = useState([]);

	const getDataSpecialized = async (departmentId: string) => {
		const getCodeDepartmentById = get(dataOptions, 'dataDepartment', '').find((item: any) => item.id === departmentId)?.id;
		setLoadingDataSpecialized(true);
		try {
			await getAllIndustry([getCodeDepartmentById]).then((res) => {
				if(res.status === 200) {
					setDataSpecialized(res.data.data);
					
					setTimeout(() => {
						setLoadingDataSpecialized(false);
					}, 333);
				}
			})
		} catch (err) {
			setLoadingDataSpecialized(false);
			console.error(err);
		}
	}

	const handleChangeDepartment = () => {
		setDataSpecialized([]);
		form.setFieldsValue({
			specialized: [],
		});
	}

	useEffect(() => {
		if(departmentId) {
			getDataSpecialized(departmentId);
		} else {
			setDataSpecialized([]);
		}
	}, [departmentId])

	return (
        <>
            <Form layout={"vertical"} form={form} onFinish={onFinish} name="createStudent" initialValues={{ status : true}}>
				{loadingForm ? 
					<div className="statistic-course-content statistic-course-loading">
						<Spin size="large" />
					</div> 
					: 
					<Row gutter={[16,16]}>
						<Col span={24}>
							<Form.Item name="name" rules={[validations.name]} label={t("Tên sinh viên", "Tên sinh viên")}>
								<FormInput placeholder={t("Nhập tên sinh viên", "Nhập tên sinh viên")} />
							</Form.Item>
						</Col>
						<Col span={24}>
							<Form.Item name="university" rules={[validations.university]} label={t("Cơ sở đào tạo", "Cơ sở đào tạo")}>
								<FormItemDropdown options={get(dataOptions, 'dataUniversity', '')} allowClear={true} placeholder={t("Chọn cơ sở đào tạo", "Chọn cơ sở đào tạo")} />
							</Form.Item>
						</Col>
						<Col span={24}>
							<Form.Item name="code" rules={[validations.code]} label={t("Mã sinh viên", "Mã sinh viên")}>
								<FormInput placeholder={t("Nhập mã sinh viên", "Nhập mã sinh viên")} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="department" rules={[validations.department]} label={t("Khoa", "Khoa")}>
								<FormItemDropdown onChange={handleChangeDepartment} options={get(dataOptions, 'dataDepartment', '')} allowClear={true} placeholder={t("Chọn khoa", "Chọn khoa")} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="specialized" rules={[validations.specialized]} label={t("Chuyên ngành", "Chuyên ngành")}>
								<FormItemDropdown disabled={!departmentId} modeDropdown="multiple" options={dataSpecialized} allowClear={true} placeholder={t("Chọn chuyên ngành", "Chọn chuyên ngành")} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="gender" rules={[validations.gender]} label={t("Giới tính", "Giới tính")}>
								<FormItemDropdown options={gendersOptions} placeholder={t("Chọn giới tính", "Chọn giới tính")} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="domicile" rules={[validations.domicile]} label={t("Nguyên quán", "Nguyên quán")}>
								<FormItemDropdown options={get(dataOptions, 'dataProvince', '')} allowClear={true} placeholder={t("Chọn nguyên quán", "Chọn nguyên quán")} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="phone" rules={[validations.phone]} label={t("Điện thoại liên hệ", "Điện thoại liên hệ")}>
								<FormInput placeholder={t("Nhập số điện thoại", "Nhập số điện thoại")} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="email" rules={[validations.email]} label={t("Địa chỉ Email", "Địa chỉ Email")}>
								<FormInput placeholder={t("Nhập địa chỉ email", "Nhập địa chỉ email")} />
							</Form.Item>
						</Col>
						<Col span={24} style={{display:"flex", justifyContent:"space-between"}}>
							<span>{t("Trạng thái", "Trạng thái")}</span>
							<Form.Item name="status">
								<Switch defaultChecked />
							</Form.Item>
						</Col>
					</Row>
				}
			</Form>
        </>
    )
}

export default FormCreateUniversity;